
"use client";
import { Carousel } from "flowbite-react";
import carouseltheme from "../themes/carousel.json"
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import anime from "animejs";
import api from "../helpers/Api";
import CarouselChild from "../components/CarouselChild";
import { SkeletonHero } from "../components/Skeleton";

export function Render({ event }) {
    let navigate = useNavigate();

    useEffect(() => {
        anime.timeline({ easing: "easeOutExpo", duration: 750 })
            .add({
                targets: ".detail-title",
                translateY: [-50, 0],
                opacity: [0, 1],
                delay: anime.stagger(200),
            })
            .add({
                targets: ".detail-description",
                translateY: [-30, 0],
                opacity: [0, 1],
                offset: "-=500",
            })
            .add({
                targets: ".detail-info div",
                translateX: [-30, 0],
                opacity: [0, 1],
                delay: anime.stagger(200),
                offset: "-=500",
            })
            .add({
                targets: ".detail-btn",
                scale: [1, 1.05],
                easing: "easeInOutQuad",
                duration: 400,
                direction: "alternate",
                loop: false,
                offset: "-=500",
            });

        anime({
            targets: ".detail-image",
            scale: [1.2, 1],
            opacity: [0, 1],
            easing: "easeOutQuad",
            duration: 1000,
        });
    }, []);

    const routeChange = (id) => {
        let path = `/event/detail/${id}`;
        navigate(path);
    }

    return (
        <div className="">
            <Carousel theme={carouseltheme} indicators={false} slideInterval={10000}>
                {event.map((value, index) => {
                    return <CarouselChild key={index} routeChange={routeChange}
                        eventId={value.event_id}
                        eventDesc={value.event_description}
                        eventPlace={value.event_location}
                        eventType={value.event_type.event_type_description}
                        eventImages={value.event_images}
                        eventName={value.event_name}
                        eventDate={value.event_date} />;
                })}
            </Carousel>
        </div>
    );
}

export function Header() {
    const [event, setEvent] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const eventsResponse = await api.get(`/Event/All`)
                setEvent(eventsResponse.data);
            } catch (error) {
                console.error("Error fetching event data:", error);
            }
        };

        fetchData();
    }, []);

    if (!event) return <SkeletonHero />;

    return <Render event={event} />;
}